import React from 'react';
import { Modal, Button, Icon, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import Colors from '../../../../themes/Colors';

const CampaignAsyncOperationModal = ({
  asyncOperation,
  retrying,
  errors,
  creationType,
  retry,
  close
}) => {
  const { t } = useTranslation();

  if (!asyncOperation) return null;

  const updating = asyncOperation.type === 'update';
  const makingProposal = creationType === 'makeProposal';
  const failed = asyncOperation.status === 'failed' && !retrying;
  const retryError = failed && errors && errors[0] !== asyncOperation.error_message ? errors[0] : null;

  const processingTitle = updating
    ? t('Saving your changes')
    : makingProposal
      ? t('Creating your proposal')
      : t('Creating your campaign');
  const failedTitle = updating
    ? t('The changes could not be saved')
    : makingProposal
      ? t('The proposal could not be created')
      : t('The campaign could not be created');

  if (!failed) {
    return (
      <Modal visible closable={false} maskClosable={false} keyboard={false} footer={null} centered>
        <div style={{ textAlign: 'center', padding: '24px 8px' }}>
          <Spin size="large" />
          <h3 style={{ marginTop: '24px' }}>{processingTitle}</h3>
          <p style={{ margin: 0 }}>
            {t('Due to the number of screens, this may take a few minutes.')}
          </p>
          {!updating && <p style={{ margin: 0 }}>{t('We will send you an email when it is ready.')}</p>}
        </div>
      </Modal>
    );
  }

  return (
    <Modal
      visible
      centered
      maskClosable={false}
      onCancel={close}
      title={
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Icon type="close-circle" style={{ marginRight: '10px', fontSize: '26px', color: Colors.red }} />
          <p style={{ margin: 0 }}>{failedTitle}</p>
        </div>
      }
      footer={[
        <Button key="close" onClick={close}>
          {t('Close')}
        </Button>,
        <Button
          key="retry"
          type="primary"
          onClick={() => retry(asyncOperation.campaign_id, asyncOperation.id)}
        >
          {t('Retry')}
        </Button>
      ]}
    >
      <p style={{ margin: '20px' }}>{asyncOperation.error_message}</p>
      {retryError && <p style={{ margin: '20px', color: Colors.red }}>{retryError}</p>}
    </Modal>
  );
};

export default CampaignAsyncOperationModal;
